import { render } from "./AddTaskTypePage.vue?vue&type=template&id=25941a54&ts=true"
import script from "./AddTaskTypePage.vue?vue&type=script&lang=ts"
export * from "./AddTaskTypePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__